import { Injectable } from '@angular/core';
import * as Parse from 'parse';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  /**
   * create/update user data information
   * @param user UserData to create or update
   * @returns { Promise } user data create or updated
   */
   async createUpdateUser(user: any): Promise<any> {
    return Parse.Cloud.run('createUpdateUser', {user: user}).then(result => { return result });
  }

  /**
   * call a cloud function to upload a file to firestore and create a linkFile
   * @param filename name of the file to upload
   * @param data data readed on base64 format to upload
   * @returns { Promise } with the directUrl uploaded
   */
   async uploadFile(filename: string, data: any): Promise<any> {
    return await Parse.Cloud.run('uploadFile', { name: filename, data: data });
  }

  /**
   * add a logo image into settings.
   * @param name string filename
   * @param fileData fileData Object readed on base64
   * @returns {Promise} return the settins object with the image added.
   */
   async addImageFirebase(name: string, fileData: any): Promise<any> {
    return this.uploadFile(name, fileData).then(result => {
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        return { success: false, data: "La imagen no pudo ser guardada" };
      }
    })
  }
}
